exports.obliqueObjectPrefixes = {
  firstSingular: "mu",
  secondSingular: "ri",
  thirdSingularAnimate: "nni",
  thirdSingularInanimate: "bi",
  firstPlural: "mee",
  secondPlural: "enee",
  thirdPluralAnimate: "nee",
  thirdPluralInanimate: ""
};
